/* eslint-disable no-async-promise-executor */
/* eslint-disable camelcase */
import api from "@/api/index";
import _ from "lodash";
import axios from "axios";
const LOGTAG = "[容器] [action]";
const LocationLog = "[getLocation]";

function loadJs(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  window.initBaiduMapScript = callback;
  script.src = `${url}&callback=initBaiduMapScript`;
  document.body.appendChild(script);
  // if (typeof callback !== "undefined") {
  //     if (script.readyState) {
  //         script.onreadystatechange = function () {
  //             if (
  //                 script.readyState == "loaded" ||
  //                 script.readyState == "complete"
  //             ) {
  //                 script.onreadystatechange = null;
  //                 callback();
  //             }
  //         };
  //     } else {
  //         script.onload = function () {
  //             callback();
  //         };
  //     }
  // }
}

export default {
  // 设置通用错误页的错误提示
  gotoErrorPage({ commit, dispatch, getters }, errCode) {
    commit("set_showErrorPage", true);
    switch (errCode) {
      case 401:
      case 402:
      case 403:
      case 404:
      case 405:
      case 406:
      case 500:
      case 501:
      case 502:
      case 503:
      case 504:
      case 505:
      case 506:
        commit("set_errorMsg", { code: "tip_network_exception" });
        break;
      case 20980001: // 数码安全校验没有通过
        commit("set_errorMsg", { code: "tip_template_notfound" });
        break;
      case 22354017:
        commit("set_errorMsg", { code: "tip_template_notfound" });
        break;
      default:
        commit("set_errorMsg", { code: errCode + "" });
        break;
    }
  },



  // 根据定位
  getIp({ commit, state, getters, dispatch }) {
    return new Promise((reverse, reject) => {
      let modulePath = "";
      let pathName = _.trimEnd(window.location.pathname, "/");
      // if (pathName.toLowerCase() === "/anti") {
      //   modulePath = pathName;
      // }

      let gpsData = { channel: "" };
      const url = `${_.trimEnd(window.dockerConfig.v2_h5_url, "/")}${modulePath}/getip`;
      axios.get(url).then(
        (res) => {
          const ip = res.data.split(",")[0];
          console.log(`[容器] [获取IP] `, ip);

          gpsData.channel = ip;

          api.getLocationByIP({ ip }).then(
            (res) => {
              if (res.code === 200 && res.data.status === 0) {
                gpsData = res.data.result;
                gpsData.channel = ip;
                gpsData.formatted_address = gpsData.formattedAddress;
              }
              reverse(gpsData);
            },
            () => {
              reverse(gpsData);
            }
          );
        },
        () => {
          reverse(gpsData);
        }
      );

      // // debugger beg
      // const ip = "60.168.130.150";
      // console.log(`[容器] [获取IP] `, ip);

      // gpsData = { channel: ip };

      // // 需要获取详细地址
      // if (isDetail) {
      //     api.getLocationByIP({ ip }).then(res => {
      //         if (res.code === 200 && res.data.status === 0) {
      //             gpsData = res.data.result;
      //             gpsData.formatted_address = gpsData.formattedAddress;
      //         }
      //         reverse(gpsData);
      //     },
      //         () => {
      //             reverse(gpsData);
      //         });
      // } else {
      //     reverse(gpsData);
      // }

      // // debugger end
    });
  },
  getClientIp({ commit, state, getters, dispatch }, data) {
    return new Promise((reverse, reject) => {
      let modulePath = "";
      let pathName = _.trimEnd(window.location.pathname, "/");
      if (pathName.toLowerCase() === "/anti") {
        modulePath = pathName;
      }

      const url = `${modulePath}/getip`;
      axios.get(url).then(
        (res) => {
          const ip = res.data.split(",")[0];
          reverse(ip);
        },
        () => {
          const ip = "";
          reverse(ip);
        }
      );
    });
  },

  /**
   *获取定位
   * @param {*} param0
   * @param {boolean} isDetail 是否获取详细信息,包括坐标系转换。默认true
   * @returns
   */
  async getLocation(
    { commit, state, getters, rootGetters, dispatch },
    isDetail = true
  ) {
    // GPS获取方式：1精准定位，2模糊定位，3不定位
    return new Promise(async (reverse, reject) => {
      // 成功获取到经纬度后执行
      async function afterSuccessGetGPS(lat, lng, coordinateType) {
        let gpsData;
        if (isDetail) {
          const data = {
            coordinateType,
            latitude: lat,
            longitude: lng,
          };
          const res = await api.getLocationByGPS(data);
          gpsData = _.get(res, "data.result");
          gpsData.coordinateType = 0; // 百度坐标
        } else {
          gpsData = {
            location: {
              lat,
              lng,
            },
            coordinateType,
          };
        }
        gpsData.channel = gpsData.location.lat + "," + gpsData.location.lng;
        gpsData.formatted_address = gpsData.formattedAddress;
        commit("set_gis", gpsData);
        // kboneAPI.hideLoading();
        reverse(gpsData);
      }

      async function getByIP() {
        let gpsData = await dispatch("getIp");
        if (_.get(gpsData, "channel")) {
          commit("set_gis", gpsData);
          reverse(gpsData);
        } else {
          reject();
        }
      }

      function getGPS() {
        const ak =
        _.get(window, "dockerConfig.baiduMapKey") ||
        "aFkbX4f7G6uWGG5o0nGXySc5CbsYSTNZ";
      loadJs(`https://api.map.baidu.com/api?v=2.0&ak=${ak}`, () => {
        const geolocation = new BMap.Geolocation();
        geolocation.enableSDKLocation();
        geolocation.getCurrentPosition(
          async function (r) {
            console.log(`[容器] [定位] 百度原始结果`, r);
            console.log(`[容器] [定位] 百度 状态`, this.getStatus());
            // eslint-disable-next-line no-undef
            if (this.getStatus() === BMAP_STATUS_SUCCESS) {
              // 授权拒绝也会进来，获取的是个不精准的位置
              console.log(`[容器] [定位] 百度 成功`);
              afterSuccessGetGPS(r.point.lat, r.point.lng, 0);
              if (r.accuracy) {
                console.log([
                  `${LocationLog}百度：同意-${
                    r.point.lat + "-" + r.point.lng
                  }-${location.href}`,
                ]);
              } else {
                  console.log([
                  `${LocationLog}百度：拒绝-${
                    r.point.lat + "-" + r.point.lng
                  }-${location.href}`,
                ]);
              }
            } else {
              console.log(`[容器] [定位] 百度 失败`);
              getByIP()
            }
          },
          async function (e) {
            console.log(`[容器] [定位] 百度 失败`, e);
            getByIP()
          }
        );
      });
      }

      if (getters.platform === "wx" && !getters.wxJssdkReady) {
        vueApp.$bus.subscribe("jssdk", async (res) => {
          getGPS();
        });
      } else {
        getGPS();
      }
    });
  },

};
